import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { StyleFormat, DownloadFormat, DocumentDownloadOptions } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSubsetPersonsDownload = ({
  matterId,
  subsetId,
}: {
  matterId: string | null;
  subsetId: string | null;
}) => {
  const { getFetchConfig } = useGetFetchConfig();

  const download = async ({
    styleFormat,
    title,
    columns,
    downloadFormat,
    documentOptions,
  }: {
    styleFormat: StyleFormat;
    downloadFormat: DownloadFormat;
    title: string;
    documentOptions?: DocumentDownloadOptions;
    columns?: string[];
  }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        downloadFormat,
        styleFormat,
        title,
        columns,
        documentOptions,
      },
    });

    const downloadResult = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/persons/download`,
      fetchConfig,
    );

    if (!downloadResult.ok) {
      throw new Error('Failed to download entities');
    }

    const blob = await downloadResult.blob();
    const link = document.createElement('a');
    const file = new Blob([blob], { type: 'text/plain' });
    link.href = URL.createObjectURL(file);

    link.download = `${title}.${downloadFormat}`;
    link.click();

    URL.revokeObjectURL(link.href);
  };

  return useMutation(download, {
    onError: () => {
      toast.error('Failed to download entities. Please try again.');
    },
  });
};
